import { MutationTree } from 'vuex';
import RootState from './RootState';
import TMAlert from '@/tools/models/TMAlert';
import User from '@/tools/models/User';

const mutations: MutationTree<RootState> = {
  setAlert(state, alert: TMAlert) {
    state.alert = alert;
  },
  setUser(state, user: User) {
    state.user = user;
  },
  subLuckySpins(state) {
    state.user.gifts -= 1;
  },
  setInitialMessageShown(state, value: boolean) {
    state.intialMessageShown = value;
  },
};

export default mutations;
